import { createContext } from "react";
export const NavContext = createContext({
    expandedTopLevelNavItems: [],
    setExpandedTopLevelNavItems: () => null,
});
export const TopLevelNavItemContext = createContext("/");
